import { render } from "./CustomButton.vue?vue&type=template&id=3f64ab4a&scoped=true"
import script from "./CustomButton.vue?vue&type=script&lang=js"
export * from "./CustomButton.vue?vue&type=script&lang=js"

import "./CustomButton.vue?vue&type=style&index=0&id=3f64ab4a&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f64ab4a"]])

export default __exports__